import { Box, Prose, Text } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  errors: string[]
  onClose: () => void
}

export const ErrorInformation = ({ errors, onClose }: Props) => {
  return (
    <Modal
      onClose={onClose}
      title={i18n.t('ats.job_details.promotion.infojobs.job.information.incorrect_fields.title')}
      illustration={'document-edit'}
      description={i18n.t(
        'ats.job_details.promotion.infojobs.job.information.incorrect_fields.description'
      )}
    >
      <Callout
        type="critical"
        title={i18n.t(
          'ats.job_details.promotion.infojobs.job.information.incorrect_fields.alert.title'
        )}
        description={i18n.t(
          'ats.job_details.promotion.infojobs.job.information.incorrect_fields.alert.description'
        )}
        action={
          <Prose color="grey1000">
            <Box component="ul">
              {errors.map((description, index) => (
                <li key={index}>
                  <Text.Normal inline color="grey1000">
                    {description}
                  </Text.Normal>
                </li>
              ))}
            </Box>
          </Prose>
        }
      />
    </Modal>
  )
}
